module.exports = __webpack_public_path__ + "img/refund.b5b14b60.svg";